import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store/store"

function requireAuth(to, from, next) {
  if (!store.state.user.user_info.phone) {
    store.dispatch('user/auth', { cb: next, params: '/auth/login' });
  }
  else {
    next()
  }
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/support/',
      redirect: () => {
        location.href = 'https://vk.com/im?sel=-187939287';
      }
    },
    {
      path: '/terms/',
      component: () => import('./views/Terrms.vue'),
      meta:{
        viewport: true,
        title:'Пользовательское соглашение'
      }
    },
    {
      path: '/privacy/',
      component: () => import('./views/Privacy.vue'),
      meta:{
        viewport: true
      }
    },
    {
      path: '/events/',
      name: 'hello_event',
      meta: {
        title: 'Cобытия',
      },
      beforeEnter: requireAuth,
      children: [
        {
          path: 'step/:step',
          name: 'eventsStep',
          meta: {
            title: 'Заполнение события',
          },
        },
        {
          path: 'edit/:eventId',
          name: 'eventEdit',
          meta: {
            title: 'Редактирование события',
          },
          component: () => import('./views/EventsEdit.vue')
        },
        {
          path: 'add/',
          name: 'eventAdd',
          meta: {
            title: 'Добавление события',
          },
        },
        {
          path: 'complete/',
          name: 'completeEvent',
          meta: {
            title: 'Заполнение события',
          },
        }
      ],
      component: () => import('./views/Events.vue')
    },
    {
      path: '/events/:eventId/',
      redirect: '/events/:eventId/posts/',
      beforeEnter: requireAuth,
    },
    {
      path: '/events/:eventId/pictures/',
      name: 'pictureslist',
      meta: {
        title: 'Управление фотографиями'
      },
      beforeEnter: requireAuth,
      component: () => import('./components/pictures/PicturesList.vue')
    },
    {
      path: '/events/:eventId/posts/',
      beforeEnter: requireAuth,
      children: [
        {
          path: '',
          name: 'postsList',
          meta: {
            title: 'Управление событиями'
          },
          component: () => import('./components/posts/PostsList.vue')
        },
        {
          path: 'add/',
          name: 'postAdd',
          meta: {
            title: 'Создание события',
          },
          component: () => import('./components/posts/PostAdd.vue')
        },
        {
          path: 'edit/:postId',
          name: 'postEdit',
          meta: {
            title: 'Создание события',

          },
          component: () => import('./components/posts/PostAdd.vue')
        },
      ],
      component: () => import('./views/Posts.vue')
    },
    {
      path: '/tarifs/',
      name: 'tarifs',
      meta: {
        title: 'Тарифы'
      },
      component: () => import('./views/Tarifs.vue')
    },
    {
      path: '/payments/',
      name: 'balance',
      meta: {
        title: ''
      },
      beforeEnter: requireAuth,
      component: () => import('./views/Payments.vue')
    },
    {
      path: '/profile/',
      name: 'hello_profile',
      meta: {
        title: 'Профиль'
      },
      beforeEnter: requireAuth,
      component: () => import('./views/Profile.vue'),
      children: [
        {
          path: 'step/:step',
          name: 'profileStep',
          meta: {
            title: 'Заполнение профиля',
          },
          component: () => import('./views/Profile.vue')
        },
        {
          path: 'complete/',
          name: 'completeProfile',
          meta: {
            title: 'Заполнение профиля',
          },
          component: () => import('./views/Profile.vue')
        }
      ],
    },

    {
      path: '/auth/',
      name: '',
      component: () => import('./views/LoginRegForm.vue'),
      children: [
        {
          path: '',
          name: 'login',
          meta: {
            title: 'Авторизация'
          },
          component: () => import('./components/forms/LoginForm.vue')
        },
        {
          path: 'login',
          alias: '',
          meta: {
            title: 'Авторизация'
          },
          component: () => import('./components/forms/LoginForm.vue')
        },
        {
          path: 'registration',
          name: 'registration',
          meta: {
            title: 'Регистрация'
          },
          component: () => import('./components/forms/RegForm.vue')
        },
        {
          path: 'password',
          name: 'password',
          meta: {
            title: 'Введите пароль'
          },
          component: () => import('./components/forms/PassForm.vue')
        },
        {
          path: 'confirmation',
          name: 'confirmation',
          meta: {
            title: 'Подтверждение телефона'
          },
          component: () => import('./components/forms/ConfirmCode.vue')
        },
      ],
    },
    {
      path: '/',
      name: 'landing',
      meta: {
        title: 'Fotty',
        viewport: true
      },
      component: () => import('./views/Landing.vue')
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
